export default __webpack_public_path__ + "media/src/assets/images/lock-d02b1443bdb6d642a33cfc79216dce1e.png";